const TIME_PATTERN = /^\d{1,2}:\d{2}$/;

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

export function isValidTimeString(jam: unknown): boolean {
  return typeof jam === "string" && TIME_PATTERN.test(jam.trim());
}

export function composeDate(tanggal: unknown, jam?: unknown): Date | null {
  if (typeof tanggal !== "string" || !tanggal.trim()) return null;

  const parts = tanggal.trim().slice(0, 10).split("-");
  if (parts.length !== 3) return null;

  const year = Number(parts[0]);
  const month = Number(parts[1]);
  const day = Number(parts[2]);
  if (!year || !month || !day) return null;

  let hour = 0;
  let minute = 0;
  if (isValidTimeString(jam)) {
    const time = (jam as string).trim().split(":");
    hour = Number(time[0]);
    minute = Number(time[1]);
  }

  return new Date(year, month - 1, day, hour, minute, 0, 0);
}

export function toDateString(val: Date | string | null): string | null {
  if (!val) return null;
  const d = val instanceof Date ? val : new Date(val);
  if (Number.isNaN(d.getTime())) return null;

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function toTimeString(val: Date | string | null): string {
  if (!val) return "";
  const d = val instanceof Date ? val : new Date(val);
  if (Number.isNaN(d.getTime())) return "";

  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
